import {ERoleId} from "../../const/dataEnum";

export const isUserAdmin = (userAuthRoleId) => {
  if (userAuthRoleId === ERoleId.ADMINISTRATOR) return true;
  return false;
}

export const isUserSuperAdmin = (userAuthRoleId) => {
  if (userAuthRoleId === ERoleId.SUPER_ADMIN) return true;
  return false;
}

export const isUserManager = (userAuthRoleId) => {
  if (userAuthRoleId === ERoleId.MANAGER) return true;
  return false;
}